import * as React from "react";
import { last } from "lodash";
import { useParameter, useDictionaryItem } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideTitle() {
  const [commName, setCommName] = React.useState("");
  const [commodities] = useParameter<string[]>("@commodities_display");
  const [business] = useParameter<number>("@business-units");
  const [commodityItem, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: Number(business),
    slide: 5,
  });
  React.useEffect(() => {
    if (commodityItem && commodityName) {
      const isSugarcane = String(last(commodities)) === "120000";
      setCommName(isSugarcane ? `${commodityName[9]}**` : commodityName[9]);
    }
  }, [commodityItem, commodityName]);

  const bname = (business || 1) === 2 ? "APE" : "World";
  const title = `${bname} overview (incl. forecast) – ${commName} area, production, yield & net trade`;
  return title;
}
